(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avantapres"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('norden-before-after')) {
    customElements.define(
      'norden-before-after',
      class extends HTMLElement {
        connectedCallback() {
          this.range = this.querySelector('input[type="range"]');
          if (!this.range || this.range.dataset.ready === 'true') return;
          this.range.dataset.ready = 'true';
          this.update = () => {
            const value = Math.min(100, Math.max(0, Number(this.range.value)));
            const beforeLabel = this.dataset.beforeLabel || 'Avant';
            const afterLabel = this.dataset.afterLabel || 'Après';
            this.style.setProperty('--nba-position', `${value}%`);
            this.range.setAttribute('aria-valuetext', `${afterLabel} ${value} %, ${beforeLabel} ${100 - value} %`);
          };
          this.range.addEventListener('input', this.update);
          this.update();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
